import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';

/**
 * Endpoints Recovery Engine — Intelligenza Recupero.
 * Spec: LEOPART_ProgrammazioneCampo_Spec_v1.1.1.md (Sez 13, 17 righe 1949-1953).
 */

export type RecoveryAlertSeverity = 'critical' | 'warning' | 'info';

export type RecoveryTriggerRule =
  | 'cognitive_back_to_back'
  | 'physical_back_to_back'
  | 'high_intensity_density'
  | 'weekly_monotony'
  | 'acwr_projection'
  | 'cognitive_dominant_md1'
  | 'physical_dominant_md1'
  | 'no_unload_day';

export interface IRecoveryAlert {
  _id: string;
  entityId: string;
  teamId: string;
  triggerType: RecoveryTriggerRule;
  severity: RecoveryAlertSeverity;
  affectedSessions: string[];
  affectedMicrocycle?: string;
  message: string;
  suggestion?: string;
  dismissedBy?: string;
  dismissedAt?: string;
  appliedSuggestion?: boolean;
  actionTaken?: 'accepted' | 'ignored' | 'modified_plan';
  createdAt: string;
  acknowledgedAt?: string;
}

export type RecoveryAlertStatus = 'active' | 'acknowledged' | 'all';

export const recoveryEngineEndpoints = {
  listAlerts: (params?: {
    teamId?: string;
    status?: RecoveryAlertStatus;
    limit?: number;
  }) =>
    axios.get<IRecoveryAlert[]>(`${baseUrl}/recovery-engine/alerts`, {
      params,
    }),

  getAlert: (id: string) =>
    axios.get<IRecoveryAlert>(`${baseUrl}/recovery-engine/alerts/${id}`),

  acknowledge: (id: string) =>
    axios.post<IRecoveryAlert>(
      `${baseUrl}/recovery-engine/alerts/${id}/acknowledge`,
      {},
    ),

  registerAction: (
    id: string,
    actionTaken: 'accepted' | 'ignored' | 'modified_plan',
  ) =>
    axios.post<IRecoveryAlert>(
      `${baseUrl}/recovery-engine/alerts/${id}/action`,
      { actionTaken },
    ),

  analyzeTeam: (teamId: string, lookbackDays = 7) =>
    axios.post<{ alerts: IRecoveryAlert[]; jobQueued: boolean }>(
      `${baseUrl}/recovery-engine/analyze/${teamId}`,
      {},
      { params: { lookbackDays } },
    ),
};
